import { authFetch, handleSessionExpired } from './authService';

const API_BASE = `${import.meta.env.VITE_API_URL || 'http://localhost:8001'}/api/v1`;

async function handleResponse<T>(response: Response): Promise<T> {
  if (response.status === 401) {
    // authFetch a déjà tenté le refresh — session réellement expirée.
    handleSessionExpired(response);
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Erreur réseau' }));
    throw new Error(error.detail || 'Erreur réseau');
  }

  // Handle 204 No Content
  if (response.status === 204) {
    return {} as T;
  }

  return response.json();
}

export const extractionService = {
  async cancelDocument(documentId: string): Promise<void> {
    const response = await authFetch(`${API_BASE}/documents/${documentId}/cancel`, {
      method: 'POST',
    });
    return handleResponse(response);
  },

  async deleteDocument(documentId: string): Promise<void> {
    const response = await authFetch(`${API_BASE}/documents/${documentId}`, {
      method: 'DELETE',
    });
    return handleResponse(response);
  },

  async getExtractionStatus(extractionId: string): Promise<{
    id: string;
    status: string;
    document_id: string;
  }> {
    const response = await authFetch(`${API_BASE}/extractions/${extractionId}`);
    return handleResponse(response);
  },

  async retryExtraction(documentId: string): Promise<void> {
    const response = await authFetch(`${API_BASE}/documents/${documentId}/retry`, {
      method: 'POST',
    });
    return handleResponse(response);
  }
};
